var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMultiChoiceGrid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_3912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.477295H0V16.4773H16V0.477295Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_411_3912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.97729H6.5V5.97729H9.5V2.97729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.97729H2.5V5.97729H5.5V2.97729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.97729H10.5V5.97729H13.5V2.97729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.97729H6.5V9.97729H9.5V6.97729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.97729H2.5V9.97729H5.5V6.97729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.97729H10.5V9.97729H13.5V6.97729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.9773H6.5V13.9773H9.5V10.9773Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.9773H2.5V13.9773H5.5V10.9773Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.9773H10.5V13.9773H13.5V10.9773Z",
    fill: "#161616"
  }))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgMultiChoiceGrid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multi-choice-grid.cda92b7872ca4a50c70d73f2ef3c2f5c.svg";